// features/workstations/property-dossier/charts.js
// Lightweight CSS/SVG charts for the Deal Dossier (no chart deps).

function fmtK(n) {
  const a = Math.abs(Number(n) || 0);
  const s = a >= 1000 ? '$' + (a / 1000).toFixed(a >= 10000 ? 0 : 1) + 'k' : '$' + Math.round(a);
  return (Number(n) < 0 ? '-' : '') + s;
}

/** Donut from slices [{label, value, color}]. */
export function CostDonut({ slices = [] }) {
  const clean = slices.filter((s) => Number(s.value) > 0);
  const total = clean.reduce((s, x) => s + Number(x.value), 0) || 1;
  let offset = 0;
  return (
    <div style={{ display: 'flex', gap: 18, alignItems: 'center', flexWrap: 'wrap' }}>
      <svg width="118" height="118" viewBox="0 0 42 42" aria-hidden="true">
        <circle cx="21" cy="21" r="15.9" fill="none" stroke="var(--surface-3)" strokeWidth="6" />
        {clean.map((s, i) => {
          const pct = (Number(s.value) / total) * 100;
          const el = (
            <circle key={i} cx="21" cy="21" r="15.9" fill="none" stroke={s.color} strokeWidth="6"
              strokeDasharray={`${pct} ${100 - pct}`} strokeDashoffset={-offset} transform="rotate(-90 21 21)" />
          );
          offset += pct;
          return el;
        })}
      </svg>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
        {clean.map((s, i) => (
          <div key={i} style={{ fontSize: 12, color: '#bbb', display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ width: 11, height: 11, borderRadius: 3, background: s.color, display: 'inline-block' }} />
            {s.label} · ${Math.round(Number(s.value)).toLocaleString()}
          </div>
        ))}
      </div>
    </div>
  );
}

/** Vertical bars from data [{label, value}]. Negative bars render terracotta. */
export function Bars({ data = [] }) {
  const max = Math.max(...data.map((d) => Math.abs(Number(d.value) || 0)), 1);
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 12, height: 124, paddingTop: 8 }}>
      {data.map((d, i) => {
        const v = Number(d.value) || 0;
        return (
          <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, height: '100%', justifyContent: 'flex-end' }}>
            <div style={{ fontSize: 10, color: '#888' }}>{fmtK(v)}</div>
            <div style={{
              width: '58%', height: `${Math.max(2, (Math.abs(v) / max) * 100)}%`,
              background: v < 0 ? '#c46050' : 'linear-gradient(180deg,#4db8b8,#2d7a7a)',
              borderRadius: '4px 4px 0 0',
            }} />
            <div style={{ fontSize: 10, color: '#888', textAlign: 'center' }}>{d.label}</div>
          </div>
        );
      })}
    </div>
  );
}
